import { render, staticRenderFns } from "./merchant-list.vue?vue&type=template&id=28c0ba7c&scoped=true&"
import script from "./merchant-list.vue?vue&type=script&lang=js&"
export * from "./merchant-list.vue?vue&type=script&lang=js&"
import style0 from "./merchant-list.vue?vue&type=style&index=0&id=28c0ba7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c0ba7c",
  null
  
)

export default component.exports